import { useState } from "react";

const AutocompleteButton = ({ items, updateItems, buttonHandler }) => {
  const [inputValue, setInputValue] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);
  const [isDropDownVisible, setIsDropDownVisible] = useState(false);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);
    console.log("AutocompleteButton handleInputChange value ", value);

    if (value) {
      const matches = items.filter((item) =>
        item?.name.toLowerCase().includes(value.toLowerCase())
      );
      console.log("AutocompleteButton matches ", matches);
      setFilteredItems(matches);
      setIsDropDownVisible(matches.length > 0);
    } else {
      console.log("AutocompleteButton no matches");
      setFilteredItems([]);
      setIsDropDownVisible(false);
    }
  };

  const handleItemSelect = (item) => {
    console.log("AutocompleteButton handleItemSelected ", item);
    setInputValue(item?.name);
    setIsDropDownVisible(false);
    updateItems(item);
  };

  const handleButtonSelected = (item) => {
    console.log("AutocompleteButton handleButtonSelected ", item);
    setInputValue("");
    buttonHandler(item);
  };

  return (
    <div className="relative w-full max-w-sm">
      <div className="flex gap-2">
        <input
          type="text"
          className="flex-1 min-w-0 border border-stone-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-600"
          value={inputValue}
          onChange={handleInputChange}
          placeholder="Search..."
        />
        <button
          type="button"
          onClick={handleButtonSelected}
          className="btn-secondary shrink-0"
        >
          Add
        </button>
      </div>
      {isDropDownVisible && (
        <ul className="absolute z-20 mt-1 w-full bg-white border border-stone-200 rounded-md shadow-sm max-h-48 overflow-y-auto">
          {filteredItems.map((item, index) => (
            <li
              key={index}
              onClick={() => handleItemSelect(item)}
              className="px-3 py-2 text-sm hover:bg-stone-100 cursor-pointer border-b border-stone-100 last:border-b-0"
            >
              {item?.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AutocompleteButton;
